import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {ChangePasswordComponent} from '../change-password/change-password.component';
import {MDBModalRef, MDBModalService, ModalContainerComponent} from 'angular-bootstrap-md';
import {LoginService} from '../login/login.service';
import {SuccessDialogComponent} from '../../shared/success-dialog/success-dialog.component';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  username = new FormControl();
  successModalRef: MDBModalRef;
  @ViewChild('forgotPswdRef', { static: true }) forgotPswdRef: ModalContainerComponent;
  action = new Subject();

  constructor(private modalService: MDBModalService, private loginService: LoginService, private router: Router) { }

  ngOnInit() {
  }

  forgotPassword() {
    this.loginService.forgotPassword(this.username.value).then((data) => {
      // alert('Success')
      this.successModalRef = this.modalService.show(SuccessDialogComponent, {
        data: {
          message: 'Password has been sent to registered email id'
        }
      });
      this.action.next('OK');

      this.successModalRef.content.action.subscribe(result => {
        if (result == 'OK') {
          this.successModalRef.hide();
          // this.action.next('save');
        }
      })

    }, (error) => {
      console.log('errr', error)
      if(error.status == 404) {
        alert(error.error.msg)
      }
      else {
        alert('Something went wrong')
      }
    })
  }


}
